/** Reine Rechenlogik des Umsatz-Szenarios, damit sie testbar bleibt. */

export type RoiInput = {
  /** Tatsächliche Sessions pro Monat, zum Beispiel 25000. */
  traffic: number;
  /** Heutige Conversion-Rate in Prozent. */
  crNow: number;
  /** Durchschnittlicher Warenkorb in Euro. */
  aov: number;
  /** Angenommene Conversion-Rate in Prozent. */
  crScenario: number;
};

export type RoiResult = {
  ordersNow: number;
  ordersScenario: number;
  revenueNow: number;
  revenueScenario: number;
  deltaMonth: number;
  deltaYear: number;
  extraOrders: number;
};

/** Wandelt Eingaben mit deutschem Komma, Punkten oder Leerzeichen in eine Zahl. */
export function parseNumber(raw: string): number {
  if (typeof raw !== "string") return 0;
  const cleaned = raw
    .replace(/\s/g, "")
    .replace(/\.(?=\d{3}\b)/g, "")
    .replace(",", ".")
    .replace(/[^0-9.-]/g, "");
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
}

export function clamp(n: number, min: number, max: number): number {
  if (!Number.isFinite(n)) return min;
  return Math.min(max, Math.max(min, n));
}

export function computeRoi(input: RoiInput): RoiResult {
  const traffic = clamp(input.traffic, 0, 100_000_000);
  const aov = clamp(input.aov, 0, 1_000_000);
  const crNow = clamp(input.crNow, 0, 100);
  const crScenario = clamp(input.crScenario, 0, 100);

  const ordersNow = (traffic * crNow) / 100;
  const ordersScenario = (traffic * crScenario) / 100;
  const revenueNow = ordersNow * aov;
  const revenueScenario = ordersScenario * aov;
  const deltaMonth = revenueScenario - revenueNow;

  return {
    ordersNow,
    ordersScenario,
    revenueNow,
    revenueScenario,
    deltaMonth,
    deltaYear: deltaMonth * 12,
    extraOrders: ordersScenario - ordersNow,
  };
}
